import * as React from "react";
const Minus = (props) => (
    <svg
        width={14}
        height={2}
        viewBox="0 0 14 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1 1h12"
            stroke={props.color || "#fff"}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default Minus;
